import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userSlice from './features/userSlice'
import subscriptionStatusSlice from './features/subscriptionStatusSlice'
import storage from 'redux-persist/lib/storage'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist'
import sessionStorage from 'redux-persist/es/storage/session'

const rootPersistConfig = {
  key: 'root',
  storage,
}

const userPersistConfig = {
  key: 'user',
  storage: sessionStorage,
}

const rootReducer = combineReducers({
  user: persistReducer(userPersistConfig, userSlice),
  // subscription status is deliberately NOT persisted: it must be re-fetched
  // on every session so a paid boleto reflects immediately.
  subscriptionStatus: subscriptionStatusSlice,
})

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
